import { render, staticRenderFns } from "./GroupDetails.vue?vue&type=template&id=26d419d8&scoped=true"
import script from "./GroupDetails.vue?vue&type=script&lang=js"
export * from "./GroupDetails.vue?vue&type=script&lang=js"
import style0 from "./GroupDetails.vue?vue&type=style&index=0&id=26d419d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d419d8",
  null
  
)

export default component.exports